import { chatQueryKeys as e } from "./useChatQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminSupportChatApi as r } from "@maat/api-chat";
//#region src/hooks/useAdminSendSupportMessageMutation.ts
var i = (i) => {
	let a = n();
	return t({
		mutationFn: (e) => r.sendMessage(i, e),
		onSuccess: () => {
			a.invalidateQueries({ queryKey: e.adminSupportMessages(i) }), a.invalidateQueries({ queryKey: e.adminSupportUnread() });
		}
	});
};
//#endregion
export { i as useAdminSendSupportMessageMutation };
